import { useWindowSize } from '@/common/hooks/useWindowSize';
import { FilterSidebarShimmer } from '@/components/FilterSidebar';
import { useFilterSidebar } from '@/hooks/FilterSidebar';
import { cn } from '@/lib/utils';
import { useCallback, useMemo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import CurrentFilters from '../FilterModal/CurrentFilters';
import FilterBlock from '../FilterModal/filterBlock';
import LinkButton from '../LinkButton';
import classes from './filterHeader.module.css';

const FilterHeader = ({ filters, aggregations, sortFields, shouldShowFilterShimmer, handleGenerateLinkHref }) => {
  const talonProps = useFilterSidebar({
    filters,
    aggregations,
    sortFields,
  });

  const windowSize = useWindowSize();

  const isMobileAndTablet = windowSize.innerWidth < 960;
  const isPC = !isMobileAndTablet;

  const { filterApi, filterItems, filterNames, filterFrontendInput, filterState, handleApply, handleReset } =
    talonProps;

  const filterRef = useRef();

  const handleApplyFilter = useCallback(
    (...args) => {
      const filterElement = filterRef.current;

      if (filterElement && typeof filterElement.getBoundingClientRect === 'function') {
        const filterTop = filterElement.getBoundingClientRect().top;
        const windowScrollY = window.scrollY + filterTop - SCROLL_OFFSET;

        window.scrollTo(0, windowScrollY);
      }

      handleApply(...args);
    },
    [handleApply, filterRef],
  );

  const filtersList = useMemo(() => {
    return Array.from(filterItems, ([group, items], iteration) => {
      const blockState = filterState.get(group);
      const groupName = filterNames.get(group);
      const frontendInput = filterFrontendInput.get(group);
      // console.log('groupName', groupName);
      // pc 端
      if (groupName === 'Price' || groupName === 'Preis' || groupName === 'quantity_and_stock_status_bucket') {
        return null;
      }

      if (groupName === 'Brand') {
        return null;
      }

      return (
        <FilterBlock
          key={group}
          filterApi={filterApi}
          filterState={blockState}
          filterFrontendInput={frontendInput}
          itemCountToShow={Infinity}
          group={group}
          items={items}
          name={groupName}
          onApply={handleApplyFilter}
          initialOpen={false}
          handleGenerateLinkHref={handleGenerateLinkHref}
        />
      );
    });
  }, [filterApi, filterItems, filterNames, filterFrontendInput, filterState, handleApplyFilter]);

  const clearAll = filterState.size ? (
    <div className={classes.action}>
      <LinkButton
        type='button'
        onClick={handleReset}
      >
        <FormattedMessage
          id={'filterModal.action'}
          defaultMessage={'Clear all'}
        />
      </LinkButton>
    </div>
  ) : null;

  if (shouldShowFilterShimmer) {
    return <FilterSidebarShimmer />;
  }

  return (
    <div className={cn(classes.root, 'lg_min-h-[50px]')}>
      <ul className={cn('flex flex-wrap items-center gap-[20px]')}>
        {/* {isPC && <span className={cn("font-oswald-bold text-primary  pr-[20px] text-[18px]   uppercase")}>Filters</span>} */}
        {filtersList}
      </ul>
      <div className={cn(classes.currentBox, 'relative w-full pr-[90px]')}>
        <CurrentFilters
          filterApi={filterApi}
          filterNames={filterNames}
          filterState={filterState}
          onRemove={handleApplyFilter}
        />
        {filterState.size > 0 && (
          <span
            className={cn(
              classes.clearAll,
              'absolute right-0 top-0 cursor-pointer font-roboto-regular text-[18px] underline',
            )}
            onClick={handleReset}
          >
            Clear All
          </span>
        )}
      </div>
    </div>
  );
};

export default FilterHeader;
